import React, { useEffect } from "react";
import { sendContactForm, getSubjectOptions, sendNotificationEmail } from "../services/contactSer";
export default function Contact() {

    const [contact, setContact] = React.useState({
        userName: "",
        email: "",
        mobileNo: "",
        subjectId: "",
        state: "",
        city: "",
        checkInDate: "",
        checkOutDate: "",
        questions: ""
    });
    const [subjectOptions, setSubjectOptions] = React.useState([]);
    const [cities, setCities] = React.useState([]);
    const toastRef = React.useRef(null);
    const [showCustomToast, setShowCustomToast] = React.useState(false);

    // Indian states and cities data
    const statesAndCities = {
        "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad", "Solapur", "Amravati", "Kolhapur", "Sangli", "Malegaon", "Jalgaon", "Akola", "Latur", "Ahmadnagar", "Dhule", "Ichalkaranji", "Parbhani", "Jalna", "Bhusawal", "Panvel", "Satara", "Beed", "Yavatmal", "Kamptee", "Gondia", "Barshi", "Achalpur", "Osmanabad", "Nanded", "Wardha", "Udgir", "Hinganghat"],
        "Karnataka": ["Bangalore", "Mysore", "Hubli", "Mangalore", "Belgaum", "Gulbarga", "Davanagere", "Bellary", "Bijapur", "Shimoga", "Tumkur", "Raichur", "Bidar", "Hospet", "Hassan", "Gadag", "Udupi", "Robertsonpet", "Bhadravati", "Chitradurga", "Kolar", "Mandya", "Chikmagalur", "Gangawati", "Bagalkot", "Chamrajnagar", "Karwar", "Ranebennur", "Madikeri", "Chikkaballapur", "Koppal", "Chintamani"],
        "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem", "Tirunelveli", "Tiruppur", "Erode", "Vellore", "Thoothukkudi", "Dindigul", "Thanjavur", "Ranipet", "Sivakasi", "Karur", "Udhagamandalam", "Hosur", "Nagercoil", "Kanchipuram", "Cuddalore", "Kumbakonam", "Tiruvannamalai", "Pollachi", "Rajapalayam", "Gudiyatham", "Pudukkottai", "Vaniyambadi", "Ambur", "Nagapattinam", "Gudur", "Sathyamangalam", "Pattukkottai"],
        "Gujarat": ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar", "Jamnagar", "Junagadh", "Gandhinagar", "Anand", "Navsari", "Morbi", "Nadiad", "Surendranagar", "Bharuch", "Mehsana", "Bhuj", "Porbandar", "Palanpur", "Valsad", "Vapi", "Gondal", "Veraval", "Godhra", "Patan", "Kalol", "Dahod", "Botad", "Amreli", "Deesa", "Jetpur", "Gondal", "Mahuva"],
        "Uttar Pradesh": ["Lucknow", "Kanpur", "Agra", "Varanasi", "Meerut", "Allahabad", "Bareilly", "Ghaziabad", "Noida", "Moradabad", "Aligarh", "Saharanpur", "Gorakhpur", "Firozabad", "Jhansi", "Muzaffarnagar", "Mathura", "Shahjahanpur", "Rampur", "Modinagar", "Hapur", "Etawah", "Mirzapur", "Bulandshahr", "Sambhal", "Amroha", "Hardoi", "Fatehpur", "Raebareli", "Orai", "Sitapur", "Bahraich"],
        "West Bengal": ["Kolkata", "Asansol", "Siliguri", "Durgapur", "Bardhaman", "Malda", "Baharampur", "Habra", "Kharagpur", "Shantipur", "Dankuni", "Dhulian", "Ranaghat", "Haldia", "Raiganj", "Krishnanagar", "Nabadwip", "Medinipur", "Jalpaiguri", "Balurghat", "Basirhat", "Bankura", "Chakdaha", "Darjeeling", "Alipurduar", "Purulia", "Jangipur", "Bangaon", "Cooch Behar", "Tamluk", "Islampur", "Kaliaganj"],
        "Rajasthan": ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Bikaner", "Ajmer", "Bharatpur", "Alwar", "Bhilwara", "Ganganagar", "Kishangarh", "Pali", "Sikar", "Beawar", "Hanumangarh", "Baran", "Dungarpur", "Sawai Madhopur", "Chittorgarh", "Tonk", "Jhunjhunu", "Banswara", "Nagaur", "Bundi", "Rajsamand", "Churu", "Karauli", "Jhalawar", "Dholpur", "Baran", "Sirohi", "Pratapgarh"],
        "Madhya Pradesh": ["Bhopal", "Indore", "Gwalior", "Jabalpur", "Ujjain", "Sagar", "Dewas", "Satna", "Ratlam", "Rewa", "Murwara", "Singrauli", "Burhanpur", "Khandwa", "Morena", "Bhind", "Chhindwara", "Vidisha", "Guna", "Shivpuri", "Damoh", "Mandsaur", "Khargone", "Neemuch", "Pithampur", "Hoshangabad", "Itarsi", "Sehore", "Harda", "Betul", "Chhatarpur", "Tikamgarh"],
        "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool", "Tirupati", "Kadapa", "Anantapur", "Chittoor", "Rajahmundry", "Kakinada", "Nizamabad", "Ongole", "Eluru", "Machilipatnam", "Tenali", "Proddatur", "Chilakaluripet", "Kadiri", "Srikakulam", "Adoni", "Gudivada", "Tadepalligudem", "Kavali", "Tadipatri", "Mangalagiri", "Narasaraopet", "Suryapet", "Miryalaguda", "Tiruvuru", "Nandyal", "Markapur"],
        "Telangana": ["Hyderabad", "Warangal", "Nizamabad", "Khammam", "Karimnagar", "Ramagundam", "Mahbubnagar", "Nalgonda", "Adilabad", "Suryapet", "Miryalaguda", "Nalgonda", "Jagtial", "Sangareddy", "Kamareddy", "Nirmal", "Mancherial", "Bodhan", "Medak", "Siddipet", "Wanaparthy", "Nagarkurnool", "Vikarabad", "Jangaon", "Bhadrachalam", "Yadadri", "Sircilla", "Asifabad", "Mahabubabad", "Huzurabad", "Korutla", "Palakurthi"]
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const subjectOptions = await getSubjectOptions();
                setSubjectOptions(subjectOptions);
            } catch (error) {
                console.error("Error fetching subject options:", error);
            }
        };


        fetchData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        if (name === "state") {
            // When state changes, update cities and reset city selection
            const selectedCities = statesAndCities[value] || [];
            setCities(selectedCities);
            setContact((prevContact) => ({
                ...prevContact,
                state: value,
                city: "" // Reset city when state changes
            }));
        } else {
            setContact((prevContact) => ({
                ...prevContact,
                [name]: value
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Save to database
            const response = await sendContactForm(contact);
            console.log("Contact form submitted successfully:", response);
            
            // Send notification email to website owner
            try {
                //await sendNotificationEmail(contact);
                console.log("Notification email sent successfully");
            } catch (emailError) {
                console.error("Error sending notification email:", emailError);
                // Don't fail the form submission if email fails
            }
            
            // show bootstrap toast if available, otherwise show a tiny fallback toast
            if (typeof window !== "undefined" && window.bootstrap && toastRef.current) {
                const bsToast = new window.bootstrap.Toast(toastRef.current);
                bsToast.show();
            } else {
                setShowCustomToast(true);
            }

            // reset form fields after successful submit
            setContact({
                userName: "",
                email: "",
                mobileNo: "",
                subjectId: "",
                state: "",
                city: "",
                checkInDate: "",
                questions: ""
            });
            setCities([]); // Reset cities dropdown
        } catch (error) {
            console.error("Error submitting contact form:", error);
        }
    };

    // auto-hide the fallback custom toast after a short delay
    useEffect(() => {
        if (!showCustomToast) return;
        const t = setTimeout(() => setShowCustomToast(false), 3000);
        return () => clearTimeout(t);
    }, [showCustomToast]);

    return (
        <section id="contact" className="contact-section-modern">
            <div className="contact-particles"></div>
            <div className="container">
                <div className="contact-header-modern text-center mb-4">
                    <div className="contact-title-wrapper">
                        <h2 className="contact-title-modern">Get in Touch</h2>
                        <div className="title-underline-modern"></div>
                    </div>
                    <p className="contact-subtitle-modern">Ready to experience luxury in the heart of nature? Let's make your dream stay a reality.</p>
                </div>
                
                <div className="row g-3">
                    <div className="col-lg-4">
                        <div className="contact-card-modern info-card">
                            <div className="card-header-modern">
                                <div className="card-icon-modern">
                                    <i className="fas fa-phone-alt"></i>
                                </div>
                                <h3>Contact Info</h3>
                            </div>
                            <div className="card-content-modern">
                                <div className="info-item-modern">
                                    <div className="info-icon">
                                        <i className="fas fa-map-marker-alt"></i>
                                    </div>
                                    <div className="info-text">
                                        <h5>Location</h5>
                                        <p>Near BajiPrabhu Statue, Panhala.</p>
                                    </div>
                                </div>
                                <div className="info-item-modern">
                                    <div className="info-icon">
                                        <i className="fas fa-phone"></i>
                                    </div>
                                    <div className="info-text">
                                        <h5>Phone</h5>
                                        <p>+91 9423043445<br/>+91 9423043437</p>
                                    </div>
                                </div>
                                <div className="info-item-modern">
                                    <div className="info-icon">
                                        <i className="fas fa-envelope"></i>
                                    </div>
                                    <div className="info-text">
                                        <h5>Email</h5>
                                        <p>hilltophotel@yahoo.com<br/>bookings@hilltophotel.com</p>
                                    </div>
                                </div>
                                <div className="info-item-modern">
                                    <div className="info-icon">
                                        <i className="fas fa-clock"></i>
                                    </div>
                                    <div className="info-text">
                                        <h5>Timings</h5>
                                        <p>Check-in: 2:00 PM<br/>Check-out: 11:00 AM</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-8">
                        <div className="contact-card-modern form-card">
                            <div className="card-header-modern">
                                <div className="card-icon-modern">
                                    <i className="fas fa-envelope-open-text"></i>
                                </div>
                                <h3>Send Message</h3>
                            </div>
                            <div className="card-content-modern">
                                <form className="contact-form-modern" onSubmit={handleSubmit}>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <div className="form-group-modern">
                                                <label className="form-label-modern">Full Name</label>
                                                <div className="input-wrapper-modern">
                                                    <i className="fas fa-user"></i>
                                                    <input
                                                        type="text"
                                                        className="form-input-modern"
                                                        placeholder="Enter your name"
                                                        name="userName"
                                                        value={contact.userName}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group-modern">
                                                <label className="form-label-modern">Email Address</label>
                                                <div className="input-wrapper-modern">
                                                    <i className="fas fa-envelope"></i>
                                                    <input
                                                        type="email"
                                                        className="form-input-modern"
                                                        placeholder="Enter your email"
                                                        name="email"
                                                        value={contact.email}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group-modern">
                                                <label className="form-label-modern">Phone Number</label>
                                                <div className="input-wrapper-modern">
                                                    <i className="fas fa-phone"></i>
                                                    <input
                                                        type="tel"
                                                        className="form-input-modern"
                                                        placeholder="Enter your phone"
                                                        name="mobileNo"
                                                        value={contact.mobileNo}
                                                        onChange={handleChange}
                                                        inputMode="tel"
                                                        maxLength={13}
                                                        pattern="^(\+91|0)?[6-9][0-9]{9}$"
                                                        required
                                                        onInput={(e) => {
                                                            // clear any custom validity as user types
                                                            e.target.setCustomValidity("");
                                                        }}
                                                        onBlur={(e) => {
                                                            // validate only when user leaves the field and there's a value
                                                            const val = e.target.value.trim();
                                                            const regex = /^(?:\+91|0)?[6-9][0-9]{9}$/;
                                                            if (val && !regex.test(val)) {
                                                                e.target.setCustomValidity("Please enter a valid 10-digit mobile number (optional +91 or leading 0)");
                                                                e.target.reportValidity();
                                                            } else {
                                                                e.target.setCustomValidity("");
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group-modern">
                                                <label className="form-label-modern">Subject</label>
                                                <div className="input-wrapper-modern">
                                                    <i className="fas fa-tag"></i>
                                                    <select
                                                        className="form-select-modern"
                                                        name="subjectId"
                                                        value={contact.subjectId}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">Select Subject</option>
                                                        {subjectOptions.map((option, id) => (
                                                            <option key={id} value={option.value}>
                                                                {option.text}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group-modern">
                                                <label className="form-label-modern">State</label>
                                                <div className="input-wrapper-modern">
                                                    <i className="fas fa-map-marker-alt"></i>
                                                    <select
                                                        className="form-select-modern"
                                                        name="state"
                                                        value={contact.state}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">Select State</option>
                                                        {Object.keys(statesAndCities).map((state, index) => (
                                                            <option key={index} value={state}>
                                                                {state}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group-modern">
                                                <label className="form-label-modern">City</label>
                                                <div className="input-wrapper-modern">
                                                    <i className="fas fa-city"></i>
                                                    <select
                                                        className="form-select-modern"
                                                        name="city"
                                                        value={contact.city}
                                                        onChange={handleChange}
                                                        disabled={!contact.state}
                                                    >
                                                        <option value="">Select City</option>
                                                        {cities.map((city, index) => (
                                                            <option key={index} value={city}>
                                                                {city}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group-modern">
                                                <label className="form-label-modern">Check-in Date</label>
                                                <div className="input-wrapper-modern">
                                                    <i className="fas fa-calendar-alt"></i>
                                                    <input
                                                        type="date"
                                                        className="form-input-modern"
                                                        name="checkInDate"
                                                        value={contact.checkInDate}
                                                        onChange={handleChange}
                                                        min={new Date().toISOString().split('T')[0]}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group-modern">
                                                <label className="form-label-modern">Check-out Date</label>
                                                <div className="input-wrapper-modern">
                                                    <i className="fas fa-calendar-alt"></i>
                                                    <input
                                                        type="date"
                                                        className="form-input-modern"
                                                        name="checkOutDate"
                                                        value={contact.checkOutDate}
                                                        onChange={handleChange}
                                                        min={contact.checkInDate || new Date().toISOString().split('T')[0]}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group-modern">
                                                <label className="form-label-modern">Message</label>
                                                <div className="input-wrapper-modern">
                                                    <i className="fas fa-comment-alt"></i>
                                                    <textarea
                                                        className="form-textarea-modern"
                                                        rows="5"
                                                        placeholder="Tell us about your requirements..."
                                                        name="questions"
                                                        value={contact.questions}
                                                        onChange={handleChange}
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="submit-btn-modern">
                                                <span className="btn-text">Send Message</span>
                                                <span className="btn-icon">
                                                    <i className="fas fa-paper-plane"></i>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="contact-footer-modern text-center mt-4">
                    <div className="social-links-modern">
                        <h4>Follow Us</h4>
                        <div className="social-icons-modern">
                            <a href="#" className="social-icon-modern facebook">
                                <i className="fab fa-facebook-f"></i>
                            </a>
                            <a href="#" className="social-icon-modern instagram">
                                <i className="fab fa-instagram"></i>
                            </a>
                            <a href="#" className="social-icon-modern twitter">
                                <i className="fab fa-twitter"></i>
                            </a>
                            <a href="#" className="social-icon-modern youtube">
                                <i className="fab fa-youtube"></i>
                            </a>
                        </div>
                    </div>
                </div>
                {/* Toast container (Bootstrap toast). Positioned fixed so it floats above content. */}
                <div aria-live="polite" aria-atomic="true" style={{ position: 'fixed', right: '1rem', bottom: '1rem', zIndex: 1080 }}>
                    <div ref={toastRef} className="toast align-items-center text-bg-success border-0" role="alert" aria-live="assertive" aria-atomic="true">
                        <div className="d-flex">
                            <div className="toast-body">Message sent successfully. We'll get back to you soon.</div>
                            <button type="button" className="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                        </div>
                    </div>

                    {/* fallback minimal toast for when Bootstrap JS isn't available */}
                    {showCustomToast && (
                        <div className="toast align-items-center text-bg-success border-0 show" role="alert" aria-live="assertive" aria-atomic="true" style={{ minWidth: 250 }}>
                            <div className="d-flex">
                                <div className="toast-body">Message sent successfully.</div>
                                <button type="button" className="btn-close btn-close-white me-2 m-auto" onClick={() => setShowCustomToast(false)} aria-label="Close"></button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );

}